import { mergeClasses } from '@blank/utilities'
import {
  Control,
  FieldError,
  RegisterOptions,
  useController,
} from 'react-hook-form'
import { HelperText } from '../../HelperText/HelperText'

export interface CheckboxProps
  extends Omit<React.HTMLProps<HTMLInputElement>, 'label'> {
  control: Control<any>
  rules?: Exclude<
    RegisterOptions,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs'
  >
  label: string | JSX.Element
  labelClassName?: string
  inputClassName?: string
  error?: FieldError
  name: string
}

export const Checkbox = ({
  name,
  control,
  rules,
  defaultValue,
  className,
  labelClassName,
  inputClassName,
  ...props
}: CheckboxProps) => {
  const {
    field: { ref, ...fieldProps },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  })

  const { id, label, error, disabled } = props

  return (
    <div
      className={mergeClasses(className, {
        '[&_*]:cursor-pointer': !(disabled || error),
      })}
    >
      <label
        className={mergeClasses(
          'inline-flex items-start text-info-400',
          labelClassName
        )}
        htmlFor={id}
      >
        <input
          {...props}
          {...fieldProps}
          checked={!!fieldProps.value}
          onChange={(e) => fieldProps.onChange((e.target as any).checked)}
          ref={ref}
          id={id}
          type="checkbox"
          className={mergeClasses(
            'mt-1 rounded border-2 border-info-400 text-primary checked:border-primary-600 focus:ring-0 focus:ring-offset-0 focus-visible:ring-2 focus-visible:ring-offset-2',
            {
              'bg-info-100': disabled,
              'border-danger': !!error,
            },
            inputClassName
          )}
        />
        <span className={mergeClasses('ml-2', { 'text-danger': !!error })}>
          {label}
        </span>
      </label>
      {!!error?.message && <HelperText color="danger" text={error.message} />}
    </div>
  )
}
